import { Navigate, generatePath } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { MLB_TEAMS_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import { PageParams } from './__generated__/routeParams';

const BaseballTeamPlayers = () => {
  const { slug } = useTypedParams<PageParams>();

  return <Navigate to={generatePath(MLB_TEAMS_SLUG, { slug })} />;
};

export default BaseballTeamPlayers;
